import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  will-change: transform, opacity;\n  position: relative;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { animated, config, useTransition } from 'react-spring';
import { APPEAR_TRANSITION_DURATION } from './constants';
import { isDefined } from '../../helpers/defined';
import { zIndex } from '../../style/z-index';
import { EMPTY_PROPS } from '../../helpers'; // transformation offset, changes from 1 (full offset) to 0 (no offset)

var getSlideTransform = function getSlideTransform(placement, offset) {
  if (offset === void 0) {
    offset = 0;
  }

  if (!placement) {
    return 'translate(0, 0)';
  }

  if (placement.startsWith('top')) {
    return "translate(0, " + 24 * offset + "px)";
  }

  if (placement.startsWith('bottom')) {
    return "translate(0, -" + 24 * offset + "px)";
  }

  if (placement.startsWith('left')) {
    return "translate(" + 24 * offset + "px, 0)";
  }

  if (placement.startsWith('right')) {
    return "translate(-" + 24 * offset + "px, 0)";
  }

  return 'translate(0, 0)';
};

var getZoomTransform = function getZoomTransform(placement, offset) {
  if (offset === void 0) {
    offset = 0;
  }

  return "scale(" + ((1 - offset) * 0.2 + 0.8) + ")";
};

var getTransformOrigin = function getTransformOrigin(placement) {
  switch (placement) {
    case 'top':
      return 'center bottom';

    case 'top-start':
      return 'left bottom';

    case 'top-end':
      return 'right bottom';

    case 'bottom':
    case 'auto':
      return 'center top';

    case 'bottom-start':
    case 'auto-start':
      return 'left top';

    case 'bottom-end':
    case 'auto-end':
      return 'right top';

    case 'left':
      return 'left center';

    case 'left-start':
      return 'left top';

    case 'left-end':
      return 'left bottom';

    case 'right':
      return 'right center';

    case 'right-start':
      return 'right top';

    case 'right-end':
      return 'right bottom';

    default:
      return 'left top';
  }
};

var WrapperContainer = styled(animated.div)(_templateObject(), function (_ref) {
  var $zIndex = _ref.$zIndex;
  return isDefined($zIndex) && zIndex($zIndex);
});
var AppearTransition = /*#__PURE__*/React.forwardRef(function (_ref2, forwardedRef) {
  var _ref2$placement = _ref2.placement,
      placement = _ref2$placement === void 0 ? 'bottom' : _ref2$placement,
      _ref2$show = _ref2.show,
      show = _ref2$show === void 0 ? false : _ref2$show,
      _ref2$duration = _ref2.duration,
      duration = _ref2$duration === void 0 ? APPEAR_TRANSITION_DURATION : _ref2$duration,
      _ref2$style = _ref2.style,
      style = _ref2$style === void 0 ? EMPTY_PROPS : _ref2$style,
      _ref2$config = _ref2.config,
      configProp = _ref2$config === void 0 ? EMPTY_PROPS : _ref2$config,
      children = _ref2.children,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'slide' : _ref2$type,
      zIndex = _ref2.zIndex,
      restProps = _objectWithoutPropertiesLoose(_ref2, ["placement", "show", "duration", "style", "config", "children", "type", "zIndex"]);

  var transitions = useTransition(show, null, {
    from: {
      opacity: 0,
      offset: 1
    },
    enter: {
      opacity: 1,
      offset: 0
    },
    leave: {
      opacity: 0,
      offset: 1
    },
    config: _objectSpread(_objectSpread({}, config.gentle), {}, {
      duration: duration
    }, configProp)
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, transitions.map(function (_ref3) {
    var item = _ref3.item,
        key = _ref3.key,
        props = _ref3.props;
    return item ? /*#__PURE__*/React.createElement(WrapperContainer, _extends({
      ref: forwardedRef,
      key: key,
      $zIndex: zIndex,
      style: _objectSpread(_objectSpread({
        opacity: props.opacity,
        pointerEvents: props.opacity.interpolate(function (o) {
          return o < 1 ? 'none' : 'auto';
        })
      }, type === 'slide' ? {
        transform: props.offset.interpolate(function (offset) {
          return getSlideTransform(placement, offset);
        })
      } : type === 'zoom' ? {
        transform: props.offset.interpolate(function (offset) {
          return getZoomTransform(placement, offset);
        }),
        transformOrigin: getTransformOrigin(placement)
      } : {}), style)
    }, restProps), children) : null;
  }));
});
export default AppearTransition;